import { render, staticRenderFns } from "./CompanyCenterAdd.vue?vue&type=template&id=12ae2e04&"
import script from "./CompanyCenterAdd.vue?vue&type=script&lang=js&"
export * from "./CompanyCenterAdd.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCenterAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports